module.exports = __webpack_public_path__ + "static/media/hike-info.9ae34461.svg";